const ResidentContractEnum = {
  FULLTIME: 1,
  PARTTIME: 2
}
export default ResidentContractEnum



// WEBPACK FOOTER //
// ./src/enum/residentContractEnum.js